import React from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from 'src/context/ThemeContext';
import { useMaintenanceStatus } from 'src/hooks/useMaintenanceStatus';
import MaintenanceScreen from 'src/shared/components/MaintenanceScreen';
import { TEFProvider } from 'src/tef/components';

interface MaintenanceGateProps {
  children: React.ReactNode;
}

const BYPASS_PATH_PREFIXES = ['/admin', '/auth/', '/newsletter/', '/sign/', '/blog/'];
const BYPASS_PATHS = new Set(['/', '/login', '/signup', '/forgot-password', '/reset-password', '/faq', '/blog']);

const MaintenanceGate: React.FC<MaintenanceGateProps> = ({ children }) => {
  const location = useLocation();
  const { window, isActive, loading } = useMaintenanceStatus();

  const path = location.pathname;
  const isBypassed = BYPASS_PATHS.has(path) || BYPASS_PATH_PREFIXES.some((p) => path.startsWith(p));

  if (loading || !isActive || isBypassed) {
    return <>{children}</>;
  }

  return (
    <ThemeProvider>
      <TEFProvider>
        <MaintenanceScreen window={window} />
      </TEFProvider>
    </ThemeProvider>
  );
};

export default MaintenanceGate;
